'use client';

import { createContext } from 'react';

import { GeoFeature, GeoLevel } from '@/types';

export type GeoContextStateValue = {
    id: string;
};

export type GeoContextActionsValue = {
    changeId: (id: string) => void;
};

export type GeoContextData = GeoFeature;

export const GeoContextState = createContext<GeoContextStateValue | null>(null);
export const GeoContextActions = createContext<GeoContextActionsValue | null>(
    null
);
export const GeoContextData = createContext<GeoContextData | null>(null);

export const GeoLevelContext = createContext<GeoLevel[] | null>(null);
